//
// Copyright © 2026 TraceX.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.

import { Card, CardSpace, MasterTag } from '@hcengineering/card'
import { Class, Ref, Timestamp } from '@hcengineering/core'
import { Employee } from '@hcengineering/contact'
import { Asset, IntlString, plugin, Plugin } from '@hcengineering/platform'

export const qalicoId = 'qalico' as Plugin

export interface RegulatoryDocument extends Card {
  applicable: boolean
  date: Timestamp
  externalLink: string
  qalicoLink: string
  owner?: Ref<Employee>
  actionsNeeded?: boolean
}

/**
 * @public
 */
const qalicoPlugin = plugin(qalicoId, {
  class: {
    RegulatoryDocument: '' as Ref<Class<RegulatoryDocument>>
  },
  space: {
    Qalico: '' as Ref<CardSpace>
  },
  icon: {
    Qalico: '' as Asset
  },
  masterTag: {
    RegulatoryDocument: '' as Ref<MasterTag>
  },
  string: {
    RegulatoryDocument: '' as IntlString
  }
})

export default qalicoPlugin
